import { getConfigValues } from 'src/config';

export const alliances = () => [
  {
    title: 'Franchise Council of Australia',
    description:
      'The Franchise Council of Australia is the peak body for the $184billion franchise business segment, which includes 1,344 networks, with 98,000+ individual franchised outlets, employing more than 598,000 people.',
    url: 'https://www.franchise.org.au/',
    imageUrl: `${getConfigValues().IMAGE_SERVER_BASE}/content/fca.png`,
  },
  {
    title: 'Franchise Relationships Institute',
    description:
      "FRI are widely regarded as the worlds's leading experts in the psychology of the franchise relationship, helping franchisors and franchisees to foster profitable partnerships.",
    url: 'https://www.franchiserelationships.com/',
    imageUrl: `${getConfigValues().IMAGE_SERVER_BASE}/content/fri.png`,
  },
  {
    title: 'Hitch',
    description:
      "Hitch is an official Franchising Council of Australia Legal Partner, advising some of Australia's leading franchise networks on compliance, franchise documentation, and Mergers & Acquisitions. Hitch delivers practical, outcome-focused legal support designed to simplify complexity and drive commercial results.",
    url: 'https://hitch.com.au/',
    imageUrl: `${getConfigValues().IMAGE_SERVER_BASE}/content/Hitch_Logo.jpg`,
  },
];
